/**
 * @description API 封装工具类
 */
import Vue from 'vue';
import VueResource from 'vue-resource';

declare module 'vue/types/vue' {
  interface VueConstructor {
    http: any;
  }
}

// 通用设置
Vue.use(VueResource);
Vue.http.options.crossOrigin = true;
Vue.http.options.xhr = {withCredentials: true};
Vue.http.interceptors.push((request: any, next: any) => {
  next((response: any) => {
    if (response && response.body && response.body.code === '302') { // 需要重定向到登录界面
      window.location.replace(response.body.redirect_url);
    }
  });
});

function get(url: any, params: any, options?: any) {
  return new Promise((resolve, reject) => {
    Vue.http.get(url, {
      params,
    }, options).then((res: any) => {
      if (res.ok && res.body) {
        resolve(res.body);
      } else {
        reject(res.body);
      }
    }).catch((res: any) => {
      reject(res);
    });
  });
}

function post(url: any, body: any, options?: any) {
  return new Promise((resolve, reject) => {
    Vue.http.post(url, body, options).then((res: any) => {
      if (res.ok && res.body) {
        resolve(res.body);
      } else {
        reject(res.body);
      }
    }).catch((res: any) => {
      reject(res);
    });
  });
}

function del(url: any, options?: any) {
  return new Promise(async (resolve, reject) => {
    Vue.http.delete(url, options).then((res: any) => {
      if (res.ok && res.body) {
        resolve(res.body);
      } else {
        reject(res.body);
      }
    }).catch((res: any) => {
      reject(res);
    });
  });
}

function put(url: any, body: any, options?: any) {
  return new Promise((resolve, reject) => {
    Vue.http.put(url, body, options).then((res: any) => {
      if (res.ok && res.body) {
        resolve(res.body);
      } else {
        reject(res.body);
      }
    }).catch((res: any) => {
      reject(res);
    });
  });
}

export default {
  get, post, del, put,
};
